import React from "react";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation();

  const about = {
    description: (
      <>
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/2fa1b670b0a6df2307369d1585d085d8db94d79896e32bbb24ee664764d7946e1626bcf1ab6907bce270063fef6f6c954222da77796972e5ac654a5f07a738fd0c1a8f010e86f169852eeb958755a89417abd9d787ae5f2552443371753b9d4a6a76c48a53c1ba2112ae305fa3e315172004f39134adc30fcece/rez-file-1750956806381.JPG"
        />
        <br />
        <p className="app-animation-translate-start text-justify">
          {t("aboutUsParagraph1")}
        </p>
        <br />
        {/* <iframe
          className="aspect-video w-full"
          src="https://drive.google.com/file/d/1Ys7iauIajeBsrjL63aW343k93hs1sFXy/preview"
        ></iframe>
        <br /> */}
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/dd8333e8adfe3ccf26a5c000d33ca86280d2b9e535afdcade863d5c4aa73f5b99b190215546d80dbfc18cdf2bce3a8ec2852ab6208bde5ebb7a05d18f20c1e1faa7099d34038eccf9cbe1179421556c245685763356c0682b59749445544ccfe2887ebdbaaca367561f74d4ff1b812ed67888e9546f5306127f1/rez-file-1750956845721.JPG"
        />
        <br />
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/d7f856f7cad6f7d83a8b5c90a5ba4f14e2b700d2a9763dfbb38bf18933bb5d17ec25aeef32e02989032abceca09a847b8cfe974c77c9813913ac154d6256729676798583c62522237b746760b8a0a78499a4bd9af69004e9abc7a81eafecd33115775defa63412d7f9975b39e3f54494eada82c361243548f486/rez-file-1750956877148.JPG"
        />
        <br />
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/56d532c0edd8b6422110cbf9971554db2c25a8949dc1274557a83ead2a70ef19c1a1143a3d3897481d81de29622e64a5e02c86b1a61b25eb7495d2a538e4bed3749516c6dcfaf9b49df5477182d2c45166cba5766ffe5f0008369887b87722239b6143f06188e2f9daa45172d3931824a4dc1c2eeac31a6b4932/rez-file-1750956898426.JPG"
        />
        <br />
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/1c51ca6ed17db46ae2cded223726634f2fe740717e12e65f792c956fa46031980aaa6fdf52196ed540d3db195e8be28e81f7e1531856aeeda0e0151dfaacfd8d3696354e2ca8b1f65e4a8b6f8613c87e77e6d14308eb7ab54770333a9488be103d0ae458bdffc035660c55b5a15af275776f0481f41265e8c644/rez-file-1750956943555.JPG"
        />
        <br />
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4494755f63995efdb1db1fcfa486937ea8aa7166bf0d473c4f2cde3ea962d4fce58ef1237ff275f0f2f47540641203f3b0c10bfb1ff06d3c0e5c688d411ddf3c45b106943c9acc6cafc84cba8f43cb7f78304704a981cad87992aa34075e8d80fffb5c0442434bc3cd375a51f75709f1ceac6078f5a4849b5cc2/rez-file-1750956970154.JPG"
        />
        <br />
        <img
          className="app-animation-translate-start"
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/04e978d38f1ed26bc433b682b47ddb62e22c33a62b3338581381067befe93381992f8445afaf78f5ef2c945c697d9099d3c95094156dfe08e4049e5239b3e41b4f5a5a5091fadd934bceab275a7a32218ae182fe2dfd0df0c007d97ac98d78b03acd94c84a9b310590a5777735de2dafcbf9550c3d005c585b6a/rez-file-1750957008141.JPG"
        />
      </>
    ),
  };

  return (
    <div>
      <section>
        <div className="relative">
          <img
            src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5d6260b8cfe0d87c4a84f3a5be2650499d800596cfce422c1df4d6ad7ef66ac73e72223a02bc359af82907bc4962a5bde782b98cf6f04acd5b072181c840dee2e83264308a41794bba2f65554c8c1370a8beb05e7e4ade2120a9cbc270fb612404aad78654ef72d443bbe9abdcef9080e234b5b041345fd706c0/file-1751858972759.JPG"
            alt="main"
            className="w-full max-h-40 sm:max-h-60 object-cover object-center"
          />
          <div className="absolute top-0 bottom-0 left-0 right-0 bg-black/60 text-white">
            <div className="app-main-container flex flex-col justify-center items-center h-full gap-4 sm:gap-8">
              <p className="text-2xl md:text-3xl/[3rem] lg:text-4xl/[3rem] max-w-md lg:max-w-xl px-8 font-bold text-center app-animation-translate-start">
                {t("aboutUsBannerText")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="app-main-container space-y-8">
          <p className="text-xl sm:text-2xl lg:text-4xl uppercase font-bold text-black text-center app-animation-translate-start">
            {t("aboutUsTitle1")}
          </p>
          <div className="text-black text-sm sm:text-base max-w-2xl mx-auto">
            {about.description}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
